// extracted by mini-css-extract-plugin
export var badge = "styles-module__badge___u8wBI";
export var clickable = "styles-module__clickable___PwsPd";